import en from "./en";
import it from "./it";
import fr from "./fr";
import bangla from "./bangla";

export default {
  bangla,
  en,
  it,
  fr
};
